import { GlobalContext } from "global/context/Provider";
import { useContext, useEffect, useState } from "react";
import Loading from "_+_Portal/components/Genericos/Loading/Loading";
import LayoutPasos from "_+_Portal/_-_Autocheckin/components/genericos/LayoutPasos/LayoutPasos";
import { setPaso } from "_+_Portal/_-_Autocheckin/context/action/paso";
import { AutocheckContext } from "_+_Portal/_-_Autocheckin/context/Provider";
import {
  BodyContainerP5,
  ButtonP5,
  CardOrden,
  ContainerP5,
} from "./localStyle";
import { showToaster } from "global/context/action/toaster/toaster";
import camelize from "global/utils/camelize";
import { resetOrdenDigitalEstudio } from "_+_Portal/context/Actions/ordenDigital/ordenDigital";
import { PortalContext } from "_+_Portal/context/Provider";
import {
  wsGetAllCentrosDemandaQr,
  wsGetAtencionSinTurno,
  wsGetVerificarOsAtencionSinTurnoQr,
  wsPostTomarAtSinTurnoQr,
} from "_+_Portal/_-_Autocheckin/context/action/atencionSinTurno";
import { hideModal, showModal } from "global/context/action/modal/modal";
import ModalTurnoParticular from "_+_Portal/_-_Autocheckin/components/genericos/ModalTurnoParticular/ModalTurnoParticular";
import { setTurnosSeleccionado } from "_+_Portal/_-_Autocheckin/context/action/turnosSeleccionados";
import { setTurnoForced } from "_+_Portal/_-_Autocheckin/context/action/turnosAutoCheckIn";
import TurnoNoEncontrado from "_+_Portal/components/Genericos/TurnoNoEcontrado/TurnoNoEncontrado";
import ScrollArrows from "_+_Portal/components/Genericos/ScrollArrows/ScrollArrows";
import ModalErrorAutoT from "_+_Portal/_-_Autocheckin/components/genericos/ModalErrorAutoT/ModalErrorAutoT";
import { getLocalStorage } from "global/utils/safeJsonParse";
import { mismoCentro, normalizarIdCentro } from "global/utils/idCentro";

const DemandaEspontanea = ({ setError }) => {
  // -------------------------  useContex  ----------------------------
  const {
    pasoDispatch,
    atencionSinTurnoDispatch,
    turnosSeleccionadosDispatch,
    turnosAutoCheckInDispatch,
  } = useContext(AutocheckContext);
  const { ordenDigitalState, ordenDigitalDispatch, selectDropDownState } =
    useContext(PortalContext);
  const { modalDispatch, toasterDispatch, authState } =
    useContext(GlobalContext);
  // -------------------------  useContex  ----------------------------

  // -------------------------  constants  ----------------------------
  const config = getLocalStorage("config", {});
  // Centros donde OSDE no está habilitado para self-service (mismo array que
  // usa TurnosDelDia; configurable desde public/config.json sin recompilar).
  const centrosBloqueoOsde = config?.centrosBloqueoOsde ?? [
    29, 21, 20, 17, 5, 16, 23, 15,
  ];
  // Resolución del paciente: primero familiar elegido, sino el titular.
  const paciente =
    selectDropDownState.selectDropDown.selectGlobal.pacienteElegido?.paciente ??
    authState.auth?.data?.paciente;
  const esOsde = paciente?.obraSocial === "OSDE";
  // -------------------------  constants  ----------------------------

  // -------------------------  useStates  ----------------------------
  const [demandaList, setDemandaList] = useState([]);
  const [loading, setLoading] = useState(true);
  const centroQR = sessionStorage.getItem("centroID");
  const idTerminal = getLocalStorage("idTerminal");
  // -------------------------  useStates  ----------------------------

  // -------------------------  funciones  ----------------------------
  const volver = () => {
    resetOrdenDigitalEstudio()(ordenDigitalDispatch);
    setPaso("Home")(pasoDispatch);
  };

  const tomarTurnoDemanda = (turno) => {
    let dissmiss = () => {
      hideModal()(modalDispatch);
    };

    // Bloqueo OSDE: si el paciente es OSDE y el centro de este turno está
    // en la lista de centros bloqueados, no se puede tomar por self-service.
    // Misma regla que aplica en TurnosDelDia (lista centrosBloqueoOsde del config).
    const centroBloqueado = centrosBloqueoOsde.includes(
      normalizarIdCentro(turno?.idCentro),
    );
    if (esOsde && centroBloqueado) {
      showModal(
        <ModalErrorAutoT
          dissmiss={dissmiss}
          errorMsg="Lamentablemente OSDE no nos habilitó para atender en este centro. Podemos ofrecerle atención en otro de nuestros centros."
        />,
        "",
        dissmiss,
        false,
        {},
        "centro",
        true,
      )(modalDispatch);
      return;
    }

    let nextStep = (isCorrect, data) => {
      setLoading(true);
      if (isCorrect) {
        if (data.codigo === 91) {
          setLoading(false);
          showModal(
            <ModalTurnoParticular
              tomarTurno={() => finalizarProyecto(turno, false, true)}
              mensajeError={data.mensaje}
              osAlternativa={true}
            />,
            "La obra social no cubre",
            dissmiss,
            false,
            {},
            "centro",
            true,
          )(modalDispatch);
        } else if (data.codigo === 9) {
          setLoading(false);
          showModal(
            <ModalTurnoParticular
              tomarTurno={() => finalizarProyecto(turno, true, false)}
              mensajeError={data.mensaje}
            />,
            "La obra social no cubre",
            dissmiss,
            false,
            {},
            "centro",
            true,
          )(modalDispatch);
        } else {
          finalizarProyecto(turno);
        }
      } else {
        setLoading(false);
        showToaster(
          {
            texto: data !== "" ? data : "Ha ocurrido un error",
            tipo: "danger",
          },
          "centroArriba",
        )(toasterDispatch);
      }
    };
    setLoading(true);
    wsGetVerificarOsAtencionSinTurnoQr(
      turno.idMedico,
      turno.idEspe,
      nextStep,
    )();
  };

  const finalizarProyecto = (turno, particular, osAlternativa) => {
    setLoading(true);
    let dto = {
      // idPaciente: paciente.codigo,
      idMedico: turno.idMedico,
      idEspecialidad: turno.idEspe,
      idCentro: turno.idCentro,
      particular,
      osAlternativa,
    };
    let nextStep = (isCorrect, element) => {
      if (isCorrect) {
        if (mismoCentro(element?.idCentro, centroQR)) {
          let turno = {
            idturno: element["idturno"],
            idMedico: element["idMedico"],
            idRecepcion: element["idRecepcion"],
            idCentro: element["idCentro"],
            medico: element["medico"],
            fecha: element["fecha"],
            hora: element["hora"],
            especialidad: element["especialidad"],
            centro: element["centro"],
            checkin: element["checkin"],
            flgSaldada: element["flgSaldada"],
            coordenadaGps: element["coordenadaGps"],
            selected: true,
            idProtocolo: element["idProtocolo"],
            presente: element["presente"],
            consultorio: element["consultorio"],
            flgSoloConsulta: element["flgSoloConsulta"],
            flgSoloPractica: element["flgSoloPractica"],
            ausente: element["ausente"],
            requiereAutorizacion: element["requiereAutorizacion"],
            estadoProtocolo: element["estadoProtocolo"],
            kinesioVerificaRecepcion: element["kinesioVerificaRecepcion"],
            osValidacionInterna: element["osValidacionInterna"],
            idEspecialidad: element["idEspecialidad"],
            resumen: {
              validaOnlineEstado: element["validaOnlineEstado"],
              validaOnline: element["validaOnline"],
              monto: element["monto"],
              medSolicitanteDto: element["medSolicitanteDto"],
              estadoOrden: element["estadoOrden"],
              tieneDeterminaciones: element["tieneDeterminaciones"],
            },
          };
          setTurnosSeleccionado([turno])(turnosSeleccionadosDispatch);
          setTurnoForced([turno])(turnosAutoCheckInDispatch);
          setPaso("NumeroAfiliado")(pasoDispatch);
        } else {
          sessionStorage.setItem("otroCentro", JSON.stringify(element));
          setPaso("OtroCentro")(pasoDispatch);
        }
        sessionStorage.removeItem("getOrdenes");
        sessionStorage.removeItem("ordenesList");
      } else {
        setError({
          message: "Error al traer el turno",
          errorBack: "Home",
        });
      }
      setLoading(false);
    };
    wsPostTomarAtSinTurnoQr(dto, nextStep)();
  };

  const advertenciaCentro = (element) => {
    sessionStorage.setItem("otroCentro", JSON.stringify(element));
    setPaso("OtroCentro")(pasoDispatch);
  };

  // -------------------------  funciones  ----------------------------

  // -------------------------  useEffect  ----------------------------
  useEffect(() => {
    let nextStep = (isCorrect, data) => {
      if (isCorrect) {
        setDemandaList(data);
        setLoading(false);
      } else {
        setLoading(false);
        showToaster(
          {
            texto: "Error al obtener los turnos.",
            tipo: "danger",
          },
          "centroArriba",
        )(toasterDispatch);
      }
    };
    if (idTerminal) {
      wsGetAtencionSinTurno(nextStep)(atencionSinTurnoDispatch);
    } else {
      wsGetAllCentrosDemandaQr(nextStep)(atencionSinTurnoDispatch);
    }
  }, []);
  // -------------------------  useEffect  ----------------------------

  return (
    <>
      <Loading
        dataLoading={loading}
        color="c-white"
        descripcion={"Cargando..."}
      />

      <LayoutPasos
        volverTo={"/autocheckin"}
        handleClick={volver}
        title={"ATENCIÓN SIN TURNO"}
        subtitle={
          "Elegí la especialidad que necesitás y presioná el botón 'Recepcionarme' para ingresarte."
        }
      >
        {!loading && (
          <ContainerP5
            initial={{ opacity: 0, y: -50 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 100 }}
            transition={{ duration: 0.4 }}
          >
            <BodyContainerP5 className="demanda-scroll-body">
              {demandaList?.length > 0 ? (
                demandaList.map((element, index) => {
                  return (
                    <CardOrden key={index}>
                      <p className="header rb18m">
                        {element?.idgrupoestudio_desc === ""
                          ? "Estudio"
                          : camelize(element?.especialidad)}
                      </p>
                      <div className="bodyOrden">
                        <p>
                          Médico:{" "}
                          <span className="rb16m">{element?.profesional}</span>
                        </p>
                        <p>
                          Demora:{" "}
                          <span className="rb16m">
                            {element?.demora === 0
                              ? "No hay demora"
                              : ` ${element?.demora} minutos`}
                          </span>
                        </p>
                        <p>
                          Centro:{" "}
                          <span className="rb16m">{element?.centro}</span>
                        </p>
                        <p>
                          Direccion:{" "}
                          <span className="rb16m">{element?.direccion}</span>
                        </p>
                        <ButtonP5
                          onClick={
                            mismoCentro(element?.idCentro, centroQR)
                              ? () => tomarTurnoDemanda(element)
                              : () => advertenciaCentro(element)
                          }
                        >
                          Recepcionarme
                        </ButtonP5>
                      </div>
                    </CardOrden>
                  );
                })
              ) : (
                <TurnoNoEncontrado
                  state={demandaList}
                  loadingState={loading}
                  recomendacion={"No se encontraron agendas disponibles."}
                />
              )}
            </BodyContainerP5>
            <ScrollArrows targetSelector=".demanda-scroll-body" />
          </ContainerP5>
        )}
      </LayoutPasos>
    </>
  );
};

export default DemandaEspontanea;
